import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../components/Loader.css';
import DressCTA from './DressCTA';
import { sortedDressImages } from '../data/categoryImageUrl';
import { responsiveImage, CARD_WIDTHS } from '../data/responsiveImage';
import { CREAM } from '../theme';

function arrowStyle(side) {
  return {
    position: 'absolute',
    top: '50%',
    [side]: 10,
    transform: 'translateY(-50%)',
    width: 32,
    height: 32,
    borderRadius: '50%',
    border: 'none',
    background: 'rgba(22,17,12,.55)',
    color: '#f3ead6',
    fontSize: 20,
    lineHeight: 1,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  };
}

export default function DressCard({ dress, categorySlug, imageUrl, onQuickView }) {
  const images = sortedDressImages(dress);
  const [hovering, setHovering] = useState(false);
  const [index, setIndex] = useState(0);
  const [loaded, setLoaded] = useState({});
  const [errored, setErrored] = useState({});

  const activeImage = images[index] || images[0];
  const src = imageUrl(activeImage);
  const href = `/categories/${categorySlug}/${dress.slug}`;

  // Warms the browser cache for the hover-swap image so the swap on first
  // hover doesn't wait on a fresh request through the images function.
  useEffect(() => {
    if (images.length > 1) {
      const img = new Image();
      img.src = imageUrl(images[1]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEnter = () => {
    setHovering(true);
    if (images.length > 1) setIndex(1);
  };
  const handleLeave = () => {
    setHovering(false);
    setIndex(0);
  };
  const prev = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIndex((i) => (i - 1 + images.length) % images.length);
  };
  const next = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIndex((i) => (i + 1) % images.length);
  };

  return (
    <div>
      <div
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
        style={{ position: 'relative', width: '100%', aspectRatio: '3 / 4', background: 'repeating-linear-gradient(135deg,#2a2016,#2a2016 14px,#231a11 14px,#231a11 28px)', border: '1px solid rgba(201,162,75,.4)', overflow: 'hidden' }}
      >
        <Link to={href} style={{ display: 'block', width: '100%', height: '100%' }}>
          {activeImage && !loaded[src] && !errored[src] && <div className="ij-loader-wrap"><span className="ij-loader" /></div>}
          {activeImage && (
            <img
              {...responsiveImage(src, CARD_WIDTHS, '(max-width: 640px) 92vw, (max-width: 1100px) 45vw, 260px')}
              alt={dress.name}
              loading="lazy"
              decoding="async"
              onLoad={() => setLoaded((s) => ({ ...s, [src]: true }))}
              onError={() => setErrored((s) => ({ ...s, [src]: true }))}
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top', opacity: loaded[src] ? 1 : 0, transition: 'opacity .4s ease' }}
            />
          )}
        </Link>

        {hovering && images.length > 1 && (
          <>
            <button onClick={prev} aria-label="Previous image" style={arrowStyle('left')}>‹</button>
            <button onClick={next} aria-label="Next image" style={arrowStyle('right')}>›</button>
          </>
        )}

        <button
          onClick={(e) => {
            e.preventDefault();
            onQuickView(dress.slug);
          }}
          style={{
            position: 'absolute',
            left: 12,
            right: 12,
            bottom: 12,
            padding: '12px 0',
            background: 'rgba(243,234,214,.92)',
            color: '#16110c',
            border: 'none',
            fontSize: 12,
            letterSpacing: '.16em',
            textTransform: 'uppercase',
            cursor: 'pointer',
            opacity: hovering ? 1 : 0,
            transition: 'opacity .2s ease',
            zIndex: 2,
          }}
        >
          Quick View
        </button>
      </div>

      <div style={{ marginTop: 16 }}>
        <Link to={href} style={{ textDecoration: 'none' }}>
          <h3 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontSize: 22, margin: '0 0 8px', color: CREAM }}>{dress.name}</h3>
        </Link>
        <DressCTA dress={dress} categorySlug={categorySlug} compact />
      </div>
    </div>
  );
}
